import gql from 'graphql-tag';

export default gql`
  fragment trackingContractFragment on TrackingContract {
    id
    isActive
  }
`;
